$(document).ready(function() {
    $('#signData').on('signed', function(e){
        if ($('.change-state-form').data('remote') == true) {
            Rails.fire($('.change-state-form')[0], 'submit');
        } else {
            $('.change-state-form').submit();
        }
    });
});
